<div class="komut-liste">
    <div>
        <img nz-image width="10em" height="10em" style="width: 13em;height: 13em;" class="mb-1"
            nzSrc="/simgeler/besgen-vektor.webp" alt="" />
    </div>
    <nz-tag nzColor="success">Resmi Anlatın</nz-tag>
    <textarea rows="2" nz-input nzSize="small" style=" resize: none;" placeholder="Üretilecek Resmi Ayrıntılı Bir Biçimde Anlatın"></textarea>
    <div style="text-align: right;">
        <button nz-button nzType="primary" nzSize="small" nzLoading="false">Üret</button>
    </div>
</div>